var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-index-impl"},[_c('main-menu',{staticClass:"main-menu"}),_c('router-view',{staticClass:"main-content-router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }